var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 9.625C13.75 10.3543 13.4603 11.0538 12.9445 11.5695C12.4288 12.0853 11.7293 12.375 11 12.375C10.2707 12.375 9.57118 12.0853 9.05546 11.5695C8.53973 11.0538 8.25 10.3543 8.25 9.625C8.25 8.89565 8.53973 8.19618 9.05546 7.68046C9.57118 7.16473 10.2707 6.875 11 6.875C11.7293 6.875 12.4288 7.16473 12.9445 7.68046C13.4603 8.19618 13.75 8.89565 13.75 9.625Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.875 9.625C17.875 16.1718 11 19.9375 11 19.9375C11 19.9375 4.125 16.1718 4.125 9.625C4.125 7.80164 4.84933 6.05295 6.13864 4.76364C7.42795 3.47433 9.17664 2.75 11 2.75C12.8234 2.75 14.572 3.47433 15.8614 4.76364C17.1507 6.05295 17.875 7.80164 17.875 9.625Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.3e7e9f3c4dcdc5f2d7b7ae2ce65aa83b.svg";
export { ForwardRef as ReactComponent };